<template>
  <div class="text-center" v-if="working">
    <div>
      <div class="spinner-border text-primary"></div>
    </div>
    {{ phrases[phrase] }}
  </div>
</template>

<script>
  export default {
    name: 'Loader',
    props: {
      working: {
        value: Boolean,
        default: false
      }
    },
    data () {
      return {
        phrases: [
          'Einen Moment bitte...',
          'Ja, wir sind noch dran!',
          'Anscheinend dauert es heute etwas länger',
          'Nicht mehr lange'
        ],
        phrase: 0
      };
    },
    watch: {
      working (v) {
        if (!v) {
          this.phrase = 0;
        }
      }
    },
    mounted () {
      window.setInterval(() => {
        this.phrase = (this.phrase + 1) % this.phrases.length;
      }, 5000);
    }
  };
</script>
